import React from 'react';
import Configurations from '@hpstellar/pdp/Configurations';

import { PriceContainer } from '../../../product/components/product-price/with-product-price';
import CTOColorPicker from '../cto-color-picker';
import withPageComponents from '../../../page/components/with-page-components';
import './specs-section.less'
const INK_COLOR_MAP = {
    black: '#000000',
    cyan: '#00FFFF',
    magenta: '#FF00FF',
    yellow: '#FFFF00'
}
const mapColors = (color) => {
    if (typeof color === 'string' && color.toLowerCase().replace(/\-|\s+/ig, '') === 'tricolor') {
        color = ['cyan', 'magenta', 'yellow']
    }
    const colors = typeof color === 'string' ? color.toLowerCase().split(',') : color;
    return colors.map(c => {
        return INK_COLOR_MAP[c] || c;
    });
}

const PrinterCartridgeColor = ({ product, category }) => {
    const { attributes } = product;
    const { prntcartclr } = attributes;
    if (prntcartclr && category === 'supplies') {
        return <Configurations
            label={'color'}
            customColor={mapColors(prntcartclr)}
            content={prntcartclr}
        />
    }
    return null;
}

const getSpecsLabel = (product, category) => {
    const { prdClass, attributes } = product;
    const { pageyielda4clr, pageyielda4bw, filter_yield } = attributes;
    let label = 'specifications';
    if (category === 'printers') {
        label = 'product information'
    } else if (prdClass in { 'VGC': 1, 'PGC': 1 }) {
        label = 'about'
    } else if ((pageyielda4clr || pageyielda4bw) && filter_yield) {
        label = 'pages'
    }
    return label;
}

const getSpecsContent = (product, prices) => {
    const { attributes, ksps } = product
    const { pageyielda4clr, pageyielda4bw, filter_yield } = attributes;
    const productPrice = prices[product.sku];
    if (pageyielda4clr || pageyielda4bw) {
        let pageYield = [
            pageyielda4clr || pageyielda4bw
        ]
        if (productPrice && filter_yield) {
            let pricePerPage = productPrice.salePrice / filter_yield
            !isNaN(pricePerPage) && pricePerPage > 0 && pageYield.push(`~$${pricePerPage.toFixed(2)}/page`);
        }
        return pageYield;
    } else {
        //TODO: temp to prevent feed issue where there are a ton of ksps
        return (ksps || []).slice(0, 8);
    }
}

const specsSection = ({ product, category }) => {
    if (product) {
        const { attributes, prdClass } = product;
        const { aiofunctions, color, displaySize } = attributes;
        /*
        DONT SHOW screen size per feedback from merch
        */
        const featuredSpec = aiofunctions || displaySize;
        const featuredSpecLbl = aiofunctions ? 'Function' : 'Screen Size';
        const specsLabel = getSpecsLabel(product, category);
        return (<div className={'pdp-specs-section'}>
            {featuredSpec && featuredSpecLbl !== 'Screen Size' && <Configurations
                label={featuredSpecLbl}
                content={featuredSpec}
            />}
            <PrinterCartridgeColor product={product} category={category} />
            <PriceContainer products={[product]}>
                {
                    ({ prices }) => {
                        return (
                            <Configurations
                                className={`specs-${specsLabel.toLowerCase().replace(/\s+/ig, '-')}`}
                                label={specsLabel}
                                content={getSpecsContent(product, prices)}
                            />);
                    }
                }
            </PriceContainer>
            {/* Don't show color per feedback from merch
            color && prdClass !== 'CTO' && <Configurations
                label='color'
                content={color}
                color={color}
                colorVariant
            />*/}
            <CTOColorPicker />
        </div>)
    }
    return null;
}

export default withPageComponents(specsSection, { components: ['product'] })
